var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftCorner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 297,
    viewBox: "0 0 264 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1436_150886",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 264,
    height: 297
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 297,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1436_150886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.27312e-05 0.499512L0 298.5L253 296.5L188 223L121.5 147L8.27312e-05 0.499512Z",
    fill: "url(#paint0_linear_1436_150886)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27312e-05 0.499512L0 298.5L253 296.5L188 223L121.5 147L8.27312e-05 0.499512Z",
    fill: "url(#paint1_linear_1436_150886)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.07147e-05 152.907L-3.10474e-05 144.724C203.214 395.526 478.62 695.876 720.442 901.497L720.442 908.312C479.116 703.695 203.904 404.035 -3.07147e-05 152.907Z",
    fill: "#FF004C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.07453e-05 86.5195L-3.10785e-05 78.3245C202.851 328.95 478.354 629.676 720.442 835.862L720.442 842.677C478.85 637.57 203.541 337.522 -3.07453e-05 86.5195Z",
    fill: "#FF004C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.06866e-05 219.226L-3.10193e-05 211.043C203.577 462.046 478.886 761.993 720.442 967.125L720.442 973.94C479.383 769.825 204.255 470.555 -3.06866e-05 219.226Z",
    fill: "#FF004C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.06565e-05 285.554L-3.09892e-05 277.371C203.94 528.537 479.141 828.134 720.442 1032.73L720.442 1039.53C479.649 835.94 204.618 537.071 -3.06565e-05 285.554Z",
    fill: "#FF004C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.06902e-05 32.5544L-3.20236e-05 -0.238953C201.411 249.672 477.313 551.829 720.442 760.085L720.442 787.357C479.346 583.166 204.207 283.833 -3.06902e-05 32.5544Z",
    fill: "url(#paint2_linear_1436_150886)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1436_150886",
    x1: 720.441,
    y1: 1468.16,
    x2: 0.00000636265,
    y2: 1468.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#550065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#631275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#6D1E80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#702283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1436_150886",
    x1: 720.441,
    y1: 1468.16,
    x2: 0.00000636265,
    y2: 1468.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#550065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#631275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#6D1E80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#702283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1436_150886",
    x1: 214432,
    y1: -4285100,
    x2: 214432,
    y2: -4867930,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFCE6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DDCB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D5C365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#C9B45B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B79F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#A0843A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#967832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#987A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B29948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#C6B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D4C164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DCCB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCorner);
export default __webpack_public_path__ + "static/media/leftCorner.4c10a916c691ac8bec0ad712b28a9a23.svg";
export { ForwardRef as ReactComponent };